import { Button } from "@chakra-ui/button"
import { Flex } from "@chakra-ui/layout"
import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from "@chakra-ui/modal"
import { Trow } from "../Produtos/Trow"
import { Title } from "../Title"
import { Tside } from "../Produtos/Tside"
import { format } from "date-fns"
import { Loader } from "../../../../../components/ComponentLoader/Loader"
import { formatPrice } from "../../../../../utils/formatPrice"
import { Tooltip } from "@chakra-ui/react"

const loadingImg = "../../../../images/loading-blue.gif"

export function ModalItem({ isOpen, onClose, data, loading, firstLetterUpper, ...rest }) {
  console.log("item modal: ", data)
  return (
    <>
      <Modal onClose={onClose} size={"full"} isOpen={isOpen}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {/*<Title>Markup innovation brindes por item - {itemsPerRow[0]?.produtos[0]?.DESCRICAO_PRODUTO}</Title>*/}
            Markup Innovation Brindes por item
          </ModalHeader>
          {/* <ModalCloseButton /> */}
          <Button onClick={onClose} alignSelf="flex-end" mr="1.5rem">
            Fechar
          </Button>

          <ModalBody overflowY="auto" width="100%" display="flex" flexDir="column" alignItems="center">
            {loading && <Loader img={loadingImg} />}

            {!loading && (
              <Flex flexDir="column">
                {/*<Flex flex={1} flexDir="column" alignItems="flex-start" m="0 auto">*/}
                {/*  <Flex alignItems="flex-start" gap={".1rem"}>*/}
                {/*    <Trow value="Data" isHead />*/}
                {/*    <Trow value="Pedido" isHead />*/}
                {/*    <Trow value="Cliente" isHead width="260px" />*/}
                {/*    <Trow value="Vendedor" isHead width="260px" />*/}
                {/*    <Trow value="Código" isHead />*/}
                {/*    <Trow value="Produto" isHead width="160px" />*/}
                {/*    <Trow value="Cor" isHead width="130px" />*/}
                {/*  </Flex>*/}
                {/*</Flex>*/}
                {/*<Flex flex={1} flexDirection="column" gap={6} alignItems="flex-start">*/}
                {/*  <Flex flexDir="column" alignItems="flex-end">*/}
                {/*    <Flex flex={1} gap={".1rem"}>*/}
                {/*      <Trow*/}
                {/*        value={*/}
                {/*          itemsPerRow[0]?.data_alteracao*/}
                {/*            ? format(new Date(itemsPerRow[0]?.data_alteracao), "dd/MM/yyyy")*/}
                {/*            : "Sem data"*/}
                {/*        }*/}
                {/*        isPrice*/}
                {/*      />*/}
                {/*      <Trow value={itemsPerRow[0]?.numero_unico ? itemsPerRow[0]?.numero_unico : "121212"} isPrice />*/}
                {/*      <Trow*/}
                {/*        value={*/}
                {/*          itemsPerRow[0]?.nome_cliente*/}
                {/*            ? itemsPerRow[0]?.nome_cliente.length > 20*/}
                {/*              ? firstLetterUpper(itemsPerRow[0]?.nome_cliente.substring(0, 20)) + "..."*/}
                {/*              : firstLetterUpper(itemsPerRow[0]?.nome_cliente)*/}
                {/*            : "Sem cliente"*/}
                {/*        }*/}
                {/*        width="260px"*/}
                {/*        isPrice*/}
                {/*      />*/}
                {/*      <Trow*/}
                {/*        value={*/}
                {/*          itemsPerRow[0]?.nome_vendedor*/}
                {/*            ? firstLetterUpper(itemsPerRow[0]?.nome_vendedor)*/}
                {/*            : "Sem vendedor"*/}
                {/*        }*/}
                {/*        width="260px"*/}
                {/*        isPrice*/}
                {/*      />*/}
                {/*      <Flex flexDir="column">*/}
                {/*        {itemsPerRow[0]?.produtos?.map((item, index) => (*/}
                {/*          <Flex gap={".1rem"} position="relative">*/}
                {/*            <Trow value={item.CODIGO_PRODUTO} isPrice />*/}

                {/*            <Trow*/}
                {/*              value={*/}
                {/*                <Tooltip label={item.DESCRICAO_PRODUTO} placement="bottom">*/}
                {/*                  {item.DESCRICAO_PRODUTO.length > 12*/}
                {/*                    ? firstLetterUpper(item.DESCRICAO_PRODUTO.substring(0, 12)) + "..."*/}
                {/*                    : firstLetterUpper(item.DESCRICAO_PRODUTO)}*/}
                {/*                </Tooltip>*/}
                {/*              }*/}
                {/*              width="160px"*/}
                {/*              isPrice*/}
                {/*            />*/}
                {/*            <Trow value={firstLetterUpper(item.COR)} width="130px" isPrice />*/}
                {/*          </Flex>*/}
                {/*        ))}*/}
                {/*      </Flex>*/}
                {/*    </Flex>*/}
                {/*  </Flex>*/}
                {/*</Flex>*/}
                {/*<Flex mt={2} position="relative">*/}
                {/*  <Trow value={""} disabled />*/}
                {/*  <Trow value={""} disabled />*/}
                {/*  <Trow value={""} disabled width="265px" />*/}
                {/*  <Flex flexDir="column" position="absolute" bottom={"2rem"} left={"15.3rem"}>*/}
                {/*    <Trow*/}
                {/*      value={parseFloat(itemsPerRow[0]?.preco_comissao).toFixed(2) + " %"}*/}
                {/*      width={"13rem"}*/}
                {/*      height="2.004rem"*/}
                {/*    />*/}
                {/*    <Trow*/}
                {/*      value={parseFloat(itemsPerRow[0]?.valor_imposto).toFixed(2) + " %"}*/}
                {/*      width={"13rem"}*/}
                {/*      height="2.004rem"*/}
                {/*    />*/}
                {/*    <Trow value={"Valor ad"} width={"13rem"} height="2.004rem" />*/}
                {/*    <Trow value={"Valor ad"} width={"13rem"} height="2.004rem" />*/}
                {/*    <Trow*/}
                {/*      value={parseFloat(itemsPerRow[0]?.valor_adiciona_loja).toFixed(2) + " %"}*/}
                {/*      width={"13rem"}*/}
                {/*      height="2.004rem"*/}
                {/*    />*/}
                {/*    <Trow value={"0.75 %"} width={"13rem"} height="2.004rem" />*/}
                {/*  </Flex>*/}

                <Flex>
                  <Flex flexDirection="column" position="relative">
                    <Tside label="Custo Produto" dashed />
                    <Tside label="Custo Impressão" border />
                    {/* <Tside label="TOTAL" isDark dashed /> */}
                    {/* <Tside label="TOTAL %" isDark dashed /> */}
                    <Tside label="Vlr unit Caixa" isDark />
                    <Tside label="Qtde por Caixa" border isDark />
                    <Tside label="Custo Total Caixa" dashed />
                    <Tside label="Cus Fix Com Vend" dashed />
                    <Tside label="Per Cus Fix Impostos" border />
                    <Tside label="Perc CusFix Adc2Rodrigo" border isDark />
                    <Tside label="Perc Cus Fix Adic 1Loja" dashed />
                    <Tside label="Cus Fix Adic 1Loja" dashed />
                    <Tside label="Perc Cus Fix Adic3 Seguranca" dashed />
                    <Tside label="Custos Fixos Percentual" dashed />
                    <Tside label="Vlr Custos Fixos Percentual" border />
                    <Tside label="OUTROS CUSTOS" dashed isDark />
                    <Tside label="Cus Fix Boleto" isDark border />
                    <Tside label="Cus Fix Frete Compra" dashed />
                    <Tside label="Markup" isDark dashed />
                    <Tside label="Vlr Custo Total" dashed isDark />
                    <Tside label="Cod Imp" isDark dashed />
                    <Tside label="Batidas" border isDark />
                    <Tside label="Prazo entrega" dashed />
                    <Tside label="Perc Com" dashed />
                    <Tside label="Nunota" dashed />
                    <Tside label="Sequencia" dashed />
                    <Tside label="Qtde Caixas Util" />
                    <Tside label="Qtde. Peça" />
                    <Tside label="Custo Corte" isDark />
                    <Tside label="Ite Hora Maquina" isDark />
                    <Tside label="Ite Tempo Corte Unit" isDark />
                  </Flex>
                  <Flex flexDirection="column" ml={1}>
                    <Trow value={formatPrice(data.Custo_Produto)} isHead width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.Custo_impressao)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.Vlr_Unit_Caixa)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.Qtde_PorCaixa)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.CustoTotalCaixa)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.CusFixComVend)} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PercCusFixImpostos + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PercCusFixAdic2Rodrigo + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PercCusFixAdic1Loja + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={data.CusFixAdic1Loja + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PercCusFixAdic3Seguranca + "%"} width={"13rem"} height="2.004rem" />
                    <Trow
                      value={parseFloat(data.CustosFixosPercentual).toFixed(2) + "%"}
                      width={"13rem"}
                      height="2.004rem"
                    />
                    <Trow
                      value={parseFloat(data.VlrCustosFixosPercentual).toFixed(2) + "%"}
                      width={"13rem"}
                      height="2.004rem"
                    />
                    <Trow value={parseFloat(data.OutrosCustos).toFixed(2) + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.CusFixBoleto)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.CusFixFreteCompra)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.Markup)} width={"13rem"} height="2.004rem" />
                    <Trow value={formatPrice(data.VlrCustoTal)} width={"13rem"} height="2.004rem" />
                    <Trow value={data.CodImp} width={"13rem"} height="2.004rem" />
                    <Trow value={data.Batidas} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PrazoEntrega} width={"13rem"} height="2.004rem" />
                    <Trow value={data.PercCom + "%"} width={"13rem"} height="2.004rem" />
                    <Trow value={data.Nunota} width={"13rem"} height="2.004rem" />
                    <Trow value={data.Sequencia} width={"13rem"} height="2.004rem" />
                    <Trow value={data.QtdeCaixaSutil} width={"13rem"} height="2.004rem" />
                    <Trow value={data.QtdPeca} width={"13rem"} height="2.004rem" />
                    <Trow value={data.CustoCorte} width={"13rem"} height="2.004rem" />
                    <Trow value={data.IteHoraMaquina} width={"13rem"} height="2.004rem" />
                    <Trow value={data.IteTempoCorteUnit} width={"13rem"} height="2.004rem" />
                    {/*    /!* <Trow value={""} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={""} width={"13rem"} height="2.004rem" /> *!/*/}

                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.produtos[0].PRECO_BRUTO)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.produtos[0].CUSTO_TOTAL)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.produtos[0].LUCRO_BRUTO)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow*/}
                    {/*      value={parseFloat(itemsPerRow[0]?.produtos[0].PORCENTAGEM).toFixed(2) + "%"}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_produto)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_unit_timp)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={"1"} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={"1"} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={"1"} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_total_imp)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.outros_custos)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.to_outroscustos)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_fix_boleto)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.custo_fix_frete_compra)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_unitario_caixa)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={itemsPerRow[0]?.quantidade_por_caixa} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={itemsPerRow[0]?.quantidade_caixa} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_total_caixa)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.valor_comissao)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_fix_impostos)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.custo_fix_rodrigo_erik)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow*/}
                    {/*      value={formatPrice(itemsPerRow[0]?.custo_fix_rodrigo_erik)}*/}
                    {/*      width={"13rem"}*/}
                    {/*      height="2.004rem"*/}
                    {/*    />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.ad_loja)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={formatPrice(itemsPerRow[0]?.custo_fix_seguranca)} width={"13rem"} height="2.004rem" />*/}
                    {/*    <Trow value={"1"} width={"13rem"} height="2.004rem" />*/}
                    {/*  </Flex>*/}
                  </Flex>
                </Flex>
              </Flex>
            )}
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
